import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/updateCatalogSorting/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showUpdateCatalogSortingSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showUpdateCatalogSortingSelector };
